import { useState } from "react";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import withLoader from "../../components/layouts/WithLoader";
import { TextField } from "@material-ui/core";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import UtilsFormule from "../../utils/UtilsFormule";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import OrderService from "../../services/PosService/OrderService";
import { useNavigate } from "react-router-dom";
const EchangePaiementTicket = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();

  const [methodePayement, setMethodePayement] = useState();
  const [datePayementCheque, setDatePayementCheque] = useState("");
  const [amount, setAmount] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [fileName, setFileName] = useState("");
  const [ref, setRef] = useState("");
  const [emetteur, setEmetteur] = useState("");

  const [infoAlertText, setInfoAlertText] = useState();
  const [file, setFile] = useState([]);
  const [payementMapById, setPayementMapById] = useState([]);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  function handleChangePayement(e) {
    let payement = e.target.value;
    setMethodePayement(payement);
  }

  const changeDatePayementCheque = (event) => {
    setDatePayementCheque(event.target.value.concat(":59"));
  };

  const changeAmount = (event) => {
    setAmount(event.target.value);
  };
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  const onUploadFileHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setFileName(e.target.files[0].name);

      setFile(e.target.files[0]);
    }
  };

  const changeRef = (event) => {
    setRef(event.target.value);
  };

  const changeEmetteur = (event) => {
    setEmetteur(event.target.value);
  };
  const chequeFields = () => {
    return (
      <>
        <div class="col-md-3">
          <label>Montant : </label>
          <input
            type="number"
            min="0"
            step="0.1"
            class="form-control"
            // placeholder="Montant "
            name="amount"
            value={amount}
            onChange={changeAmount}
          />
        </div>
        <div class="col-md-3">
          <label>Référence: </label>
          <input
            value={ref}
            onChange={changeRef}
            class="form-control"
            placeholder="Référence"
            type="text"
          />
        </div>
        <div class="col-md-3">
          <label>Emetteur: </label>
          <input
            value={emetteur}
            onChange={changeEmetteur}
            class="form-control"
            placeholder="Référence"
            type="text"
          />
        </div>
        <div class="col-md-3">
          <label>Date de l'échéance </label>
          <br />
          <TextField
            style={{ width: "100%" }}
            className="col-sm-12"
            variant="outlined"
            value={datePayementCheque}
            onChange={changeDatePayementCheque}
            id="datetime-local"
            type="datetime-local"
            defaultValue="date"
            InputLabelProps={{
              shrink: true,
            }}
            size="small"
          />
        </div>
        {/* <div className="row">
          <div className="col-sm-12">
            <div class="form-group">
              <label for="exampleInputFile">Ajouter chèque </label>
              <div class="input-group">
                <div class="custom-file">
                  <input
                    accept="application/pdf, .jpg, .jpeg, .png"
                    type="file"
                    className="custom-file-input"
                    id="exampleInputFile"
                    onChange={onUploadFileHandler}
                  />
                  <label class="custom-file-label" for="exampleInputFile">
                    {fileName}{" "}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </>
    );
  };

  const virementFields = () => {
    return (
      <>
        <div class="col-md-4">
          <label>Montant : </label>
          <input
            type="number"
            min="0"
            step="0.1"
            class="form-control"
            // placeholder="Montant "
            name="amount"
            value={amount}
            onChange={changeAmount}
          />
        </div>
        <div class="col-md-4">
          <label>Référence: </label>
          <input
            value={ref}
            onChange={changeRef}
            class="form-control"
            placeholder="Référence"
            type="text"
          />
        </div>{" "}
      </>
    );
  };
  const especeFields = () => {
    return (
      <>
        <div class="col-md-4">
          <label>Montant : </label>
          <input
            type="number"
            min="0"
            step="0.1"
            class="form-control"
            // placeholder="Montant "
            name="amount"
            value={amount}
            onChange={changeAmount}
          />
        </div>
      </>
    );
  };

  const tpeFields = () => {
    return (
      <>
        <div class="col-md-4">
          <label>Montant : </label>
          <input
            type="number"
            min="0"
            step="0.1"
            class="form-control"
            // placeholder="Montant "
            name="amount"
            value={amount}
            onChange={changeAmount}
          />
        </div>
        <div class="col-md-4">
          <label>Référence: </label>
          <input
            value={ref}
            onChange={changeRef}
            class="form-control"
            placeholder="Référence"
            type="text"
          />
        </div>{" "}
      </>
    );
  };

  const carteCadeauFields = () => {
    return (
      <>
        <div class="col-md-4">
          <label>Montant : </label>
          <input
            type="number"
            min="0"
            step="0.1"
            class="form-control"
            // placeholder="Montant "
            name="amount"
            value={amount}
            onChange={changeAmount}
          />
        </div>
        <div class="col-md-4">
          <label>Référence: </label>
          <input
            value={ref}
            onChange={changeRef}
            class="form-control"
            placeholder="Référence"
            type="text"
          />
        </div>{" "}
      </>
    );
  };
  const ristourneFields = () => {
    return (
      <>
        <div class="col-md-4">
          <label>Montant : </label>
          <input
            type="number"
            min="0"
            step="0.1"
            class="form-control"
            // placeholder="Montant "
            name="amount"
            value={amount}
            onChange={changeAmount}
          />
        </div>
        <div class="col-md-4">
          <label>Référence: </label>
          <input
            value={ref}
            onChange={changeRef}
            class="form-control"
            placeholder="Référence"
            type="text"
          />
        </div>{" "}
      </>
    );
  };
  const passFields = () => {
    return (
      <>
        <div class="col-md-4">
          <label>Montant : </label>
          <input
            type="number"
            min="0"
            step="0.1"
            class="form-control"
            // placeholder="Montant "
            name="amount"
            value={amount}
            onChange={changeAmount}
          />
        </div>
        <div class="col-md-4">
          <label>Référence: </label>
          <input
            value={ref}
            onChange={changeRef}
            class="form-control"
            placeholder="Référence"
            type="text"
          />
        </div>{" "}
      </>
    );
  };

  const onAddProductToList = (event) => {
    setPayementMapById((previoustate) => [
      ...previoustate,
      {
        typePayement: methodePayement,
        ammountPayed: amount,
        ref: ref,
        dateCheque: datePayementCheque,
        emetteur: emetteur,
      },
    ]);

    console.log("productTableData ", payementMapById);
  };

  function payementTypeFormatter(cell, row) {
    if (row.typePayement == 0) {
      return <span>ESPECE</span>;
    } else if (row.typePayement == 1) {
      return <span>TPE</span>;
    } else if (row.typePayement == 2) {
      return <span>CHEQUE / TRAITE</span>;
    } else if (row.typePayement == 3) {
      return <span>VIREMENT</span>;
    } else if (row.typePayement == 4) {
      return <span>CARTE CADEAU</span>;
    } else if (row.typePayement == 6) {
      return <span>RISTOURNE</span>;
    } else if (row.typePayement == 7) {
      return <span>CHEQUE CADEAU</span>;
    }
  }
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const terminer = (event) => {
    let payement = {
      idUser: getCurrentUserId(),
      idPI: sessionStorage.getItem("idPayementEchange"),
      payementInfoEchangeModels: payementMapById,
    };
    startLoading();
    OrderService.echangePayementOrder(payement)
      .then((response) => {
        console.log("response", response);
        setOpenSuccessAlert(true);
        setSuccessAlertText("Enregistrement avec succées");
        sessionStorage.removeItem("idPayementEchange");
        sessionStorage.removeItem("refPayementEchange");
        sessionStorage.removeItem("typePayementEchange");

        sessionStorage.removeItem("amountPayementEchange");
        setTimeout(() => {
          navigate(`/magasins`);
        }, 2000);
      })
      .catch((error) => {
        console.log("error", error);
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : " + error);
      })
      .finally(() => {
        stopLoading();
      });
    console.log("payement ", payement);
  };

  function dateFormatter(cell, row) {
    if (row.dateCheque != null && row.dateCheque !== "") {
      return <span>{UtilsFormule.formatDateHours(row.dateCheque)}</span>;
    }
  }
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const columnsWithDelete = [
    {
      dataField: "typePayement",
      text: "type de payement",
      formatter: payementTypeFormatter,
      headerAlign: "center",
    },
    {
      dataField: "ref",
      text: "Reference",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "dateCheque",
      text: "Date",
      align: "center",
      headerAlign: "center",
      formatter: dateFormatter,

      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "emetteur",
      text: "Emetteur",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },

    {
      dataField: "ammountPayed",
      text: "Montant",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
  ];

  function handleTableChange({ payementMapById }) {
    return payementMapById;
  }
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6"></div>
          </div>
        </div>
      </section>

      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  Ancient Payement:{" "}
                  {sessionStorage.getItem("refPayementEchange")}-
                  {sessionStorage.getItem("typePayementEchange")}:
                  {sessionStorage.getItem("amountPayementEchange")} DNT
                </div>
                <div class="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <label>Choisir le type de payement</label>
                      <select
                        class="form-control"
                        onChange={handleChangePayement}
                      >
                        <option key={0} value={"No Choice"}>
                          Sélectionner un mode de payement
                        </option>
                        <option key={1} value={0}>
                          Espèce
                        </option>
                        <option key={2} value={1}>
                          TPE
                        </option>
                        <option key={3} value={2}>
                          Chèques / Traites
                        </option>
                        <option key={4} value={3}>
                          Virement
                        </option>
                        <option key={5} value={4}>
                          Carte cadeau
                        </option>
                        <option key={6} value={6}>
                          Ristourne
                        </option>
                        <option key={7} value={7}>
                          Chèque cadeau
                        </option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    {methodePayement == 0 && especeFields()}
                    {methodePayement == 1 && tpeFields()}
                    {methodePayement == 2 && chequeFields()}
                    {methodePayement == 3 && virementFields()}
                    {methodePayement == 4 && carteCadeauFields()}
                    {methodePayement == 6 && ristourneFields()}
                    {methodePayement == 7 && passFields()}
                  </div>
                  <br />
                  <div class="row">
                    <div className="col-sm-12  text-center">
                      <button
                        style={{ marginBottom: 20 }}
                        className="btn btn-dark"
                        onClick={onAddProductToList}
                      >
                        <i class="fas fa-plus"></i>
                        Liste des paiements
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        {payementMapById && (
                          <ToolkitProvider
                            keyField="idProduct"
                            data={payementMapById}
                            columns={columnsWithDelete}
                            onTableChange={handleTableChange}
                          >
                            {(props) => (
                              <div>
                                <div className="row">
                                  <BootstrapTable
                                    {...props.baseProps}
                                    striped
                                    hover
                                    condensed
                                  />
                                </div>
                              </div>
                            )}
                          </ToolkitProvider>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div className="col-sm-12  text-right">
                    <button className="btn btn-dark" onClick={terminer}>
                      Terminer
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(EchangePaiementTicket);
